import React, { useState } from 'react';

const OnboardingSuccess = ({ hotelName, hotelId, summary, onContinue, continueLabel = 'Continue to Login', subtitle = 'Sign in with the email and password you just created to access your dashboard.', footer = null }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #FFE6CC 0%, #FFCC99 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: '640px',
          width: '100%',
          background: '#fff',
          borderRadius: '20px',
          padding: '36px',
          boxShadow: '0 20px 60px rgba(255,119,0,0.15), 0 4px 12px rgba(0,0,0,0.05)',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            width: '72px',
            height: '72px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #16a34a, #22c55e)',
            color: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '2rem',
            fontWeight: '700',
            lineHeight: 1,
            margin: '0 auto 20px',
            boxShadow: '0 8px 24px rgba(22,163,74,0.3)',
          }}
        >
          ✓
        </div>

        <h1
          style={{
            margin: '0 0 8px',
            color: '#333',
            fontSize: '1.6rem',
            fontWeight: '800',
            textAlign: 'center',
          }}
        >
          Property Created Successfully!
        </h1>

        <p
          style={{
            margin: '0 0 24px',
            color: '#666',
            fontSize: '0.95rem',
            textAlign: 'center',
          }}
        >
          {hotelName} • ID: {hotelId}
        </p>

        {Array.isArray(summary) && summary.length > 0 && (
          <div
            style={{
              width: '100%',
              marginBottom: '8px',
            }}
          >
            {summary.map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '12px 0',
                  borderBottom: '1px solid #f1f5f9',
                }}
              >
                <span
                  style={{
                    color: '#666',
                    fontSize: '13px',
                    fontWeight: '600',
                  }}
                >
                  {item.label}
                </span>
                <span
                  style={{
                    color: '#333',
                    fontSize: '14px',
                    fontWeight: '500',
                    textAlign: 'right',
                    flex: 1,
                    marginLeft: '16px',
                  }}
                >
                  {item.value}
                </span>
              </div>
            ))}
          </div>
        )}

        <button
          type="button"
          onClick={onContinue}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={{
            width: '100%',
            background: 'linear-gradient(135deg, #FF7700, #FF8800)',
            color: '#ffffff',
            border: 'none',
            padding: '14px 32px',
            borderRadius: '10px',
            fontWeight: '600',
            fontSize: '1rem',
            cursor: 'pointer',
            boxShadow: hovered
              ? '0 8px 20px rgba(255,119,0,0.4)'
              : '0 4px 12px rgba(255,119,0,0.3)',
            transform: hovered ? 'translateY(-2px)' : 'translateY(0)',
            transition: 'all 0.3s ease',
            marginTop: '24px',
          }}
        >
          {continueLabel}
        </button>

        <p
          style={{
            margin: '16px 0 0',
            color: '#666',
            fontSize: '0.85rem',
            textAlign: 'center',
          }}
        >
          {subtitle}
        </p>

        {footer}
      </div>
    </div>
  );
};

export default OnboardingSuccess;
